import { Component } from "react"
import PropTypes from "prop-types"
import { map } from "lodash"
import classnames from "classnames"
import Row from "./row"

export default class CompareTablePanel extends Component {
  static propTypes = {
    columns: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string.isRequired,
      color: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    })).isRequired,
    items: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string.isRequired,
      fn: PropTypes.func.isRequired,
    })),
    data: PropTypes.array.isRequired,
  }

  render() {
    const { items, data, columns } = this.props

    return <div className={classnames("compare-panel fixed")}>
      {map(items, ({ label, fn }, index) => <div key={index} className="panel-row">
        <div className={classnames("panel-label")}>{label}</div>
        {map(columns, (column, index) => <Row key={index} column={column} data={data} index={index} selector={fn} />)}
      </div>)}
    </div>
  }
}
